import { createApp } from 'vue';
import Faqs from "./components/faqs";
import TestimonialCarousel from "./components/testimonial-carousel";
import TabbedHighlights from "./components/tabbed-highlights";
import FeatureHighlightsRotator from "./components/feature-highlights-rotator";
import Modal from "./components/modal";
import SignUpForm from "./components/sign-up-form";
import LinkStackDropdown from "./components/link-stack-dropdown";
import DayCarousel from "./components/day-carousel";
import CountUp from 'vue-countup-v3';

// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {};
}

const vueApp = createApp({
    components: {
        Faqs,
        TestimonialCarousel,
        TabbedHighlights,
        FeatureHighlightsRotator,
        Modal,
        SignUpForm,
        LinkStackDropdown,
		DayCarousel,
		CountUp
    },
    data() {
        return {
            navigation: {
                open: false,
                openSubMenus: [],
                openTopSubMenu: null,
                isSticky: false
            },
        };
    },
    methods: {
        toggleMenu() {
            this.navigation.open = !this.navigation.open;
        },
        toggleTopSubMenu(id, event) {
            if (window.innerWidth >= 1280 && id !== this.navigation.openTopSubMenu) {
                event.preventDefault();
                return;
            }
        },
        toggleSubMenu: function(id) {
            let alreadyOpenedSubMenu = this.navigation.openSubMenus.indexOf(id);

            if (alreadyOpenedSubMenu > -1) {
                this.navigation.openSubMenus.splice(alreadyOpenedSubMenu, 1);
            } else {
                this.navigation.openSubMenus.push(id);
            }
        },
        subMenuIsOpen: function(id) {
            return this.navigation.openSubMenus.indexOf(id) > -1;
        },
        handleScroll() {
            this.navigation.isSticky = window.scrollY >= 700;
        }
    },
    mounted() {},
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.handleScroll);
    },
}).mount('#vue-app');